import React from 'react';
import { Link } from 'react-router-dom';
const SingleItem = ({ data, index, handleEnableDisabled, handleDelete }) => {


    return (
        <>
            <tr>
                <td data-label="Username">
                    <Link to={`/admin/user/details/${data?.user_id?._id}`}>
                        <span>{data?.user_id?.username}</span>
                    </Link>
                </td>
                <td data-label="Currency">
                    <span className="d-block"> {data?.currency}</span>
                </td>
                <td data-label="Wallet Name">
                    {data?.wallet_name}
                </td>
                <td data-label="Withdrawal Address">
                    {data?.withdrawal_address}
                </td>
                <td data-label="Network">
                    {data?.network}
                </td>

                <td data-label="Status">
                    {data?.status ?
                        <span class="badge badge--success text-success">Enabled</span>
                        :
                        <span><span class="badge badge--warning text-warning">Disabled</span></span>
                    }
                </td>
                <td data-label="Action">
                    <div class="button-group">
                        <Link to={`/admin/withdraw/method/edit/${data._id}`} class="btn btn-sm btn-outline-primary editGatewayBtn">
                            <i class="la la-pencil"></i> Edit
                        </Link>
                        {data?.status ?
                            <button onClick={() => handleEnableDisabled(data._id)} class="btn btn-sm btn-outline-danger confirmationBtn" >
                                <i class="la la-eye-slash"></i> Disable                                                </button>
                            :
                            <button onClick={() => handleEnableDisabled(data._id)} class="btn btn-sm btn-outline-success confirmationBtn" >
                                <i class="la la-eye"></i> Enable                                                </button>
                        }
                         <button class="btn btn-sm btn-outline-danger " onClick={() => handleDelete(data?._id)} ><i class="la la-trash"></i> Remove</button>
                    </div>
                </td>





            </tr>
        </>
    );
};

export default SingleItem;